namespace GpScot.Main {
	document.addEventListener('DOMContentLoaded', () => {
		GpScot.SearchFilterSectionExpander.init();
		GpScot.PageClassSetter.init();
		GpScot.Downloads.init();
		GpScot.ResponsiveTables.init();
		GpScot.MobileClasses.init();
		GpScot.PromoGroups.init();
	});
}